var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabGam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 538.087,
    height: 550.201,
    viewBox: "0 0 538.087 550.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M331.606,72.421a33.476,33.476,0,1,0-33.47,33.459,33.476,33.476,0,0,0,33.47-33.459m16.535,0A50.011,50.011,0,1,1,298.131,22.41a50.011,50.011,0,0,1,50.011,50.011",
    transform: "translate(-248.12 -22.41)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2725",
    "data-name": "Rectangle 2725",
    width: 16.535,
    height: 28.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2729",
    "data-name": "Rectangle 2729",
    width: 28.034,
    height: 16.535,
    transform: "translate(19.823 31.515) rotate(-135)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2733",
    "data-name": "Rectangle 2733",
    width: 16.535,
    height: 28.034,
    transform: "translate(11.692 31.515) rotate(-135)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2735",
    "data-name": "Rectangle 2735",
    width: 16.535,
    height: 28.034,
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 11.694, 31.517)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    width: 28.034,
    height: 16.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M320,363.025,278.04,299.864a111.975,111.975,0,0,1-15.094,12.487c-20.114,13.831-44.391,20.746-72.619,20.746a192.064,192.064,0,0,1-21.507-1.263l-34.464,31.192Zm-66.514-64.343a94.308,94.308,0,0,0,15.175-13.037l-18.446-27.791-64.36,58.5h4.438c24.827,0,45.994-5.863,63.259-17.718M302.948,210,262.7,246.532l16.924,25.492c14.268-21.054,20.568-45.249,23.337-62.044m54.205-49.2-35.63,32.391c-.68,13.151-4.988,58.141-32.1,93.738l50.5,76.117h192.5V379.56H0V363.025H109.739L147.895,328.4a333.351,333.351,0,0,1-49.736-14.576l5.782-15.5a294.884,294.884,0,0,0,59.437,15.984L345.963,148.6Z",
    transform: "translate(0 -148.6)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2742",
    "data-name": "Rectangle 2742",
    width: 216.676,
    height: 16.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    width: 50.723,
    height: 16.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    width: 58.692,
    height: 16.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    width: 135.538,
    height: 16.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2750",
    "data-name": "Rectangle 2750",
    width: 52.327,
    height: 16.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2752",
    "data-name": "Rectangle 2752",
    width: 119.084,
    height: 16.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    d: "M58.692,329.52H240.256v16.536H0V329.52Z",
    transform: "translate(0 -329.52)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    d: "M107.7,6.1A43.728,43.728,0,0,1,135.05,32.695c14.948-8.47,34.658-4.68,35.759-4.47a8.276,8.276,0,0,1-3.239,16.2c-.227,0-23.4-4.308-30.075,8.551a8.243,8.243,0,0,1-7.32,4.437,8.421,8.421,0,0,1-1.927-.227,8.292,8.292,0,0,1-6.365-7.968c0-.858-.486-20.843-19.612-27.532A8.276,8.276,0,0,1,107.7,6.1",
    transform: "translate(-97.338 -5.835)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5149",
    "data-name": "Path 5149",
    d: "M234.024,52.516a8.26,8.26,0,0,1-3.32,11.191c-.21.113-20.729,11.693-17.6,25.912a8.3,8.3,0,0,1-14.414,7.142c-.551-.648-13.75-15.677-32.7-8.567a8.285,8.285,0,1,1-5.733-15.547A43.727,43.727,0,0,1,198.3,75.529c6.041-16.1,23.6-25.815,24.584-26.333a8.243,8.243,0,0,1,11.207,3.32",
    transform: "translate(-154.834 -48.187)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    d: "M307.806,10.49v399.8H291.27V27.025H224v119.2H140.169v35.824H16.972v84.345H.42v-100.9H123.633V129.687H207.46V10.49Z",
    transform: "translate(-0.42 -10.49)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2372",
    "data-name": "Group 2372",
    transform: "translate(36.229 36.294)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2723",
    "data-name": "Rectangle 2723",
    width: 100.022,
    height: 100.022,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2373",
    "data-name": "Group 2373",
    transform: "translate(77.98)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2724",
    "data-name": "Rectangle 2724",
    width: 16.535,
    height: 28.034,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374",
    transform: "translate(77.98 144.445)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2726",
    "data-name": "Rectangle 2726",
    width: 16.535,
    height: 28.034,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2375",
    "data-name": "Group 2375",
    transform: "translate(121.543 121.557)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2728",
    "data-name": "Rectangle 2728",
    width: 31.516,
    height: 31.516,
    transform: "translate(0.002 0.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    transform: "translate(19.395 19.411)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2730",
    "data-name": "Rectangle 2730",
    width: 31.516,
    height: 31.516,
    transform: "translate(0.007 -0.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2377",
    "data-name": "Group 2377",
    transform: "translate(19.415 121.518)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2732",
    "data-name": "Rectangle 2732",
    width: 31.516,
    height: 31.516,
    transform: "translate(-0.03 0.044)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2378",
    "data-name": "Group 2378",
    transform: "translate(121.595 19.427)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2734",
    "data-name": "Rectangle 2734",
    width: 31.516,
    height: 31.516,
    transform: "translate(-0.018 -0.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2379",
    "data-name": "Group 2379",
    transform: "translate(0 77.98)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2736",
    "data-name": "Rectangle 2736",
    width: 28.034,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2380",
    "data-name": "Group 2380",
    transform: "translate(144.429 77.98)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    width: 28.034,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2381",
    "data-name": "Group 2381",
    transform: "translate(5.652 240.661)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2740",
    "data-name": "Rectangle 2740",
    width: 532.418,
    height: 230.96,
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2382",
    "data-name": "Group 2382",
    transform: "translate(321.395 497.275)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2741",
    "data-name": "Rectangle 2741",
    width: 216.676,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2383",
    "data-name": "Group 2383",
    transform: "translate(253.034 497.275)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2743",
    "data-name": "Rectangle 2743",
    width: 50.723,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2384",
    "data-name": "Group 2384",
    transform: "translate(162.373 497.275)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    width: 58.692,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2385",
    "data-name": "Group 2385",
    transform: "translate(5.668 497.275)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    width: 135.538,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2386",
    "data-name": "Group 2386",
    transform: "translate(5.668 533.666)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2749",
    "data-name": "Rectangle 2749",
    width: 52.327,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    transform: "translate(78.385 533.666)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2751",
    "data-name": "Rectangle 2751",
    width: 119.084,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2388",
    "data-name": "Group 2388",
    transform: "translate(215.121 533.666)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2753",
    "data-name": "Rectangle 2753",
    width: 50.723,
    height: 16.535,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2389",
    "data-name": "Group 2389",
    transform: "translate(297.83 533.666)",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2755",
    "data-name": "Rectangle 2755",
    width: 240.256,
    height: 16.535,
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2390",
    "data-name": "Group 2390",
    transform: "translate(300.849 9.45)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2756",
    "data-name": "Rectangle 2756",
    width: 82.515,
    height: 51.809,
    transform: "translate(-1.674 -0.202)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2391",
    "data-name": "Group 2391",
    transform: "translate(207.142 78.04)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2757",
    "data-name": "Rectangle 2757",
    width: 82.45,
    height: 51.404,
    transform: "translate(-1.09 -0.011)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2392",
    "data-name": "Group 2392",
    transform: "translate(230.021 16.989)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2758",
    "data-name": "Rectangle 2758",
    width: 307.386,
    height: 399.796,
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabGam);
export default __webpack_public_path__ + "static/media/tab-gam.406e379288691b10d765c09b7b20119a.svg";
export { ForwardRef as ReactComponent };